import {isMobile} from '../utils/device';

const ESCAPE_KEYCODE = 27;

class Modal {
    constructor (modalId, $content)
    {
        this.modalId = modalId;
        this.$content = $content;
        this.includeCloseButton = true;
        this.preventBodyScroll = true;
        this.escKeyClosesModal = true;
        this.preventDuplicate = true;
        this.parentSelector = 'body';
        this.beforeOpenCallback = function () {};
        this.afterOpenCallback = function () {};
        this.beforeCloseCallback = function () {};
        this.afterCloseCallback = function () {};
        this.afterContentCallback = function () {};
        this.isInitialized = false;
        this.transitionDuration = 0;
        this.modalOpenHtmlClass = 'modal-is-open';
    }

    initialize()
    {
        this.buildModal();
        this.populateContent(this.$content);
        this.onModalCreated();
        this.addListeners();

        this.isInitialized = true;
    }

    onModalCreated()
    {

    }

    addListeners()
    {
        this.$modalContainer.on('click', (e) => {
            const $el = $(e.target);

            if ($el.closest('.modal').length)
            {
                return;
            }

            this.close();
        });

        $(document).on('click', '.js-close-modal', (e) => {
            e.preventDefault();

            this.close();
        });

        $(document).on('touchmove', '.js-modal-content', (e) => {
            this.preventTouchOverscroll(e);
        });

        $(document).on('keydown', (e) => {
            this.onKeyDown(e.which);
        });
    }

    open()
    {
        if (! this.isInitialized)
        {
            this.initialize();
        }

        this.getScrollbarWidth();
        this.beforeOpenCallback(this.$modal);
        $(this.parentSelector).append(this.$modalContainer);
        this.setHtmlClass(true);
        this.preventBodyScroll && this.stopBodyFromScrolling();
        setTimeout(() => {
            this.$modalContainer.addClass('open');
        }, 1000 / 60);
        setTimeout(() => {
            this.afterOpenCallback();
        }, this.transitionDuration);
    }

    close()
    {
        if (this.$modalContainer.length === 0)
        {
            throw ('Modal has not been initialized!');
        }

        this.determineTransitionDuration();
        this.beforeCloseCallback(this.$modal);
        this.$modalContainer.removeClass('open');
        this.setHtmlClass(false);

        setTimeout(() => {
            this.$modalContainer.remove();

            if (this.preventBodyScroll)
            {
                $(this.parentSelector).removeClass('u-overflow-hidden');
            }

            this.afterCloseCallback();
        }, this.transitionDuration);
    }

    populateContent($content)
    {
        if ($content instanceof jQuery)
        {
            this.contentHtml = $($content);
        }
        else
        {
            this.contentHtml = $content;
        }

        if (this.$modal.length && this.contentHtml !== '' && typeof this.contentHtml !== 'undefined')
        {
            this.$modal.find('.js-modal-content').empty().html(this.contentHtml);
        }

        this.afterContentCallback();
    }

    buildModal()
    {
        const icon = (this.includeCloseButton === true ? '<a href="#0" class="modal__close js-close-modal"><svg class="icon-close" width="21" height="21"> <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use></svg></a>' : '');
        const html = `<div class="modal-container" id="modal-${this.modalId}"><div class="modal">${icon}<div class="modal-content js-modal-content"></div></div></div>`;

        this.$modalContainer = $(html);
        this.$modal = this.$modalContainer.find('.modal');
    }

    setHtmlClass(modalOpen)
    {
        if (modalOpen)
        {
            $('html').addClass(this.modalOpenHtmlClass);
        }
        else
        {
            $('html').removeClass(this.modalOpenHtmlClass);
        }
    }

    onKeyDown(which)
    {
        // esc
        if (which === ESCAPE_KEYCODE && this.escKeyClosesModal)
        {
            this.close();
        }
    }

    determineTransitionDuration()
    {
        const transitionCss = this.$modal.css('transition-duration');
        const transitions = transitionCss.match(/[0-9\.]+/g);

        if (!transitions)
        {
            return;
        }

        let maxTransition = 0;
        transitions.map(function (transition) {
            const transitionFloat = parseFloat(transition);
            maxTransition = transitionFloat > maxTransition ? transitionFloat : maxTransition;
        });

        this.transitionDuration = maxTransition * 1000;
    }

    stopBodyFromScrolling()
    {
        if (! $("#modal-open-scrollbar-offset").length)
        {
            const width = this.getScrollbarWidth();
            isMobile() || $('head').append(`<style id="modal-open-scrollbar-offset">html.${this.modalOpenHtmlClass} body { overflow: hidden; } html.${this.modalOpenHtmlClass} header { padding-right:${width}px; width: calc(100% - ${width}px); } html.${this.modalOpenHtmlClass} #content { padding-right:${width}px; box-sizing: border-box; }</style>`);
        }
    }

    preventTouchOverscroll(e)
    {
        // If the element is tall enough to scroll
        const target = e.currentTarget;

        if (target.scrollTop === 0)
        {
            target.scrollTop = 1;
        }
        else if (target.scrollHeight === target.scrollTop + target.offsetHeight)
        {
            target.scrollTop -= 1;
        }

        // If it's too short for scrolling
        if (target.offsetHeight === target.scrollHeight)
        {
            e.preventDefault();
        }
    }

    getScrollbarWidth()
    {
        const scrollDiv = document.createElement('div');
        scrollDiv.className = 'modal-scrollbar-measure';
        document.body.appendChild(scrollDiv);
        const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);

        return scrollbarWidth;
    }
}

export default Modal;


// WEBPACK FOOTER //
// ./app/src/js/modules/Modal.js